import {
  ItemInterface,
  InputType,
} from "src/app/common/components/form-builder/form-builder.component";
import { environment } from "src/environments/environment";

export class ChoferFormDefinition {
  public appName = environment.appName;
  public lastFieldChanged: string = "";

  public requestType: any;
  public model: any = {};

  public formFieldsDatos: ItemInterface<any>[] = [
    {
      field: "nombre",
      label: "Nombre",
      inputType: { type: InputType.EDIT_TEXT },
      required: true,
    },
  ];

  public formChanges(tag: string) {
    this.lastFieldChanged = tag;
  }
}
